import './App.scss';
import Item from './Item';
import Bag from './Bag';
import { useState, useEffect } from 'react';
import languages from "./lang.json";

function App() {

  const [itemList, setItemList] = useState([]);

  const [bagTypeList, setBagTypeList] = useState(
    () => {
      const saved = localStorage.getItem("ListeBags");
      const initialValue = JSON.parse(saved);
      if(initialValue?.length === 0) {
        return [{'ID':0,'Name': 'Sac 🎒','Color':'#F3DE8A'}]
      }
      return initialValue || [{'ID':0,'Name': 'Sac 🎒','Color':'#F3DE8A'}];
    });
  const [bagTypeAdded, setBagTypeAdded] = useState('');
  const [emoji, setEmoji] = useState('');
 const [info, setInfo] = useState(false);
 const [lang,setLang] = useState('FR');
 const [texte,setTexte] = useState();

  useEffect(() => { 
    setTexte(languages[lang])

  },[lang]);



  useEffect(() => {
    let itemsListe = JSON.parse(localStorage.getItem('ListeItems'));
    let bagListe = JSON.parse(localStorage.getItem('ListeBags'));
    if(itemsListe !== null && itemsListe.length > 0){
      setItemList(itemsListe);
    }
    if(bagListe !== null && bagListe.length > 0){
      setBagTypeList(bagListe);
    }
  }, []); 

  useEffect(() => {
    localStorage.setItem('ListeItems', JSON.stringify(itemList));
  }, [itemList]);

  useEffect(() => {
    localStorage.setItem('ListeBags', JSON.stringify(bagTypeList));
  }, [bagTypeList])




  function handleAddingBagType(){
    if(bagTypeAdded){
      setBagTypeList([...bagTypeList,{'ID':new Date().getTime(),'Name':bagTypeAdded + emoji,'Color':'#F3DE8A'}]);
      setBagTypeAdded('');
      setEmoji('');

    }
  }

  function handlingSettingItem(addedItem, nomBag){
    setItemList([...itemList,{'ID':new Date().getTime(),'Name':addedItem.Name,'Quantity':addedItem.Quantity,'Bag':nomBag}]);
  }

  function deletingItem(id){
    setItemList(itemList => itemList.filter(item => item.ID !== id));
  }

  function deletingBag(id){
    let toDelete = bagTypeList.find(bag => bag.ID === id);
    setBagTypeList(bagTypeList => bagTypeList.filter(bag => bag.ID !== id));
    let itemToDelete = itemList.filter(item => item.Bag === toDelete.Name);
    if(itemToDelete){
      itemToDelete.map(item => deletingItem(item.ID));
    }
  }

  function changedColor(color,bag){
    let changedBag = bagTypeList.find(sac => sac.ID === bag.ID);
    let newBagList = [...bagTypeList];
    newBagList.find(bag => bag === changedBag).Color = color;
    setBagTypeList(newBagList);
  }

  function changeQt(item,operation){
    let changedItem = itemList.find(objet => objet === item);
    let newItemList = [...itemList];
    if(operation && item.Quantity !== 100){
      newItemList.find(item => item === changedItem).Quantity++;
    } else if(!operation && item.Quantity !== 1){
      newItemList.find(item => item === changedItem).Quantity--;
    }
    setItemList(newItemList);
  }
  

  return (
    <div className="App">

    <div className="flag-container">
      <img className='flag' onClick={()=> setLang('FR')} src="flag/france.svg" alt="france-flag"/>
      <img className='flag' onClick={()=> setLang('EN')} src="flag/uk.svg" alt="uk-flag"/>
      <img className='flag' onClick={()=> setLang('RO')} src="flag/romania.svg" alt="romanian-flag"/>
    </div>  


      <h1>🎒{texte?.titre}🧳</h1>

      <button className="infoButton" onClick={() => setInfo(!info)}>{!info && "ℹ"}{info && <b>X</b>}</button>
        {    info &&  
            <div className="information">
            <h4>{texte?.info1}</h4>
            <p>{texte?.info2}</p>
            <ol>
              <li>{texte?.info3}</li>
              <li>{texte?.info4}</li>
              <li>{texte?.info5}</li>
              <li>{texte?.info6}</li>
            </ol>
            <h5>{texte?.info7}</h5>
            <h6><i>{texte?.info8}<a style={{'color':' #5fbf01'}} href="https://guillaumeguichard.dev/" target="_blank" rel="noopener noreferrer">Guillaume Guichard</a></i></h6>
          </div>
      }

      <div className="add-category">
          <input
          placeholder={texte?.labelSac}
          value={bagTypeAdded}
          onChange={(e)=> setBagTypeAdded(e.target.value)}
          maxLength='20'
          />

          <select value={emoji} onChange={(e)=> setEmoji(e.target.value)}>
            <option></option>
            <option>🎒</option>
            <option>🧳</option>
            <option>💼</option>
            <option>👜</option>
            <option>👝</option>
            <option>🛍️</option>
            <option>📦</option>
            <option>🎁</option>
            <option>🚚</option>
            <option>🚗</option>
          </select>
            <button className="button-input" onClick={() => handleAddingBagType()} disabled={bagTypeAdded ? false : true}>{texte?.ajoutSac}</button>
      </div>

      
      <div className="bag-container">
            {
              bagTypeList?.length > 0 ? (
                bagTypeList.map((bag) =>{
                  return <Bag key={bag.ID} bag={bag} itemList={itemList} texte={texte} changedColor={changedColor} handlingSettingItem={handlingSettingItem} deletingItem={deletingItem} changeQt={changeQt} deleteBag={deletingBag} textEmpty={texte?.pasobjet}/>
                })
              ) : (
              <h3>{texte?.pasbag}</h3>
              )
            }
      </div>


      <h2>{texte?.objets}:</h2>
        
      {
        itemList?.length > 0 ? (
          itemList.map((item) =>{
          return <Item key={item.ID} item={item} isAll={true} deleteItem={deletingItem}/>
          })
        ) : (
         <h3>{texte?.pasobjet}</h3>
        )
      }
 
    </div>
  );
}

export default App;
